import { IApplicationError } from '../shared/application-error';

export interface ImpersonationTokenValidationModel {
    tokenValue: string;
    hasPassword: boolean;
    tokenValidationErrorType: number;
    locale: string;
    languageId: number;
    applicationError: IApplicationError;
    participantName: string;
    participantEmailAddress: string;
    otac: string;
}
